<template>
    <DCard padding>
        <DRow
            class="mb-3"
            align-vertical="end"
        >
            <DCol
                sm="12"
            >
                <DButton
                    id="table-configuration"
                    icon="cog-outline"
                    :label="__('messages.list_configuration')"
                    class="float-end"
                    @click="showListViewModal = true"
                />
            </DCol>
        </DRow>

        <CollectionFilter
            v-model:invoice-id="filter.invoiceId"
            v-model:customer-id="filter.customerId"
            v-model:customer-search="filter.customerSearch"
            v-model:invoice-price-operator="filter.invoicePriceOperator"
            v-model:invoice-price="filter.invoicePrice"
            v-model:exclude-invoices-with-open-incidents="filter.excludeInvoicesWithOpenIncidents"
            v-model:currency="filter.currency"
            :currency-codes="currencyCodes"
            @filter="applyFilter"
        />
        <DTable
            :key="tableKey"
            class="table-responsive table-sticky-header"
            :items="form.invoices"
            :fields="getFields()"
        >
            <template #debit_loss-header>
                <div class="header-actions">
                    {{ __('tools.in_lawsuit.headers.debit_loss') }}
                    <DFormCheck
                        id="header_debit_loss"
                        v-model="headerActions.debit_loss"
                        inline
                        type="radio"
                        :name="'header'"
                        :checked="headerActions.debit_loss"
                        @click="onClickAllActions('debit_loss')"
                    />
                </div>
            </template>
            <template #ignore-header>
                <div class="header-actions">
                    {{ __('tools.in_lawsuit.headers.ignore') }}
                    <DFormCheck
                        id="ignore"
                        v-model="headerActions.ignore"
                        inline
                        type="radio"
                        :name="'header'"
                        :checked="headerActions.ignore"
                        @click="onClickAllActions('ignore')"
                    />
                </div>
            </template>
            <template #debit_loss="{item}">
                <td>
                    <DFormCheck
                        :id="`action_${item.id}_debit_loss`"
                        v-model="item.debit_loss"
                        inline
                        type="radio"
                        :name="item.id"
                        :checked="item.debit_loss"
                        @change="onChangeActions(item, 'debit_loss')"
                    />
                </td>
            </template>
            <template #ignore="{item}">
                <td>
                    <DFormCheck
                        :id="`action_${item.id}_ignore`"
                        v-model="item.ignore"
                        inline
                        type="radio"
                        :name="item.id"
                        :checked="item.ignore"
                        @change="onChangeActions(item, 'ignore')"
                    />
                </td>
            </template>
            <template #id="{item}">
                <td v-if="userPermissions.includes('invoice.view')">
                    <Link :href="showInvoiceRoute(item)">
                        {{ item.id }}
                    </Link>
                </td>
                <td v-else>
                    {{ item.id }}
                </td>
            </template>
            <template #customer_firstname="{item}">
                <td>{{ item.customer.firstname }}</td>
            </template>
            <template #customer_lastname="{item}">
                <td>{{ item.customer.lastname }}</td>
            </template>
            <template #customer_company="{item}">
                <td>{{ item.customer.company }}</td>
            </template>
            <template #customer_id="{item}">
                <td v-if="userPermissions.includes('customer.view')">
                    <Link :href="customerInvoicesRoute(item)">
                        {{ item.customer.id }}
                    </Link>
                </td>
                <td v-else>
                    {{ item.customer.id }}
                </td>
            </template>
            <template #total_amount="{item}">
                <td>{{ roundPrice(item.total_amount, item.customer.market_region_id) }}</td>
            </template>

            <template #open_item_amount="{item}">
                <td>{{ roundPrice(item.open_item_amount, item.customer.market_region_id) }}</td>
            </template>
            <template #sanity="{item}">
                <td>{{ __('customers.common.sanity.' + item.customer.sanity) }}</td>
            </template>
            <template #products="{item}">
                <td>
                    <div
                        v-for="(product, index) in item.products"
                        :key="index"
                    >
                        {{ product }}
                    </div>
                </td>
            </template>
        </DTable>
        <DFabs>
            <DFab
                id="btn-add"
                icon="file-export"
                :label="__('tools.in_lawsuit.set_debt_loss')"
                @click="handoverCollections"
            />
        </DFabs>
        <ListViewModal
            v-if="showListViewModal"
            :show-modal="showListViewModal"
            :user-list-view="userListView"
            @close-modal="showListViewModal = false"
        />
    </DCard>
</template>

<script>
import CollectionFilter from '~@/Components/Tools/Collection/Filter.vue'
import ListViewModal from '~@/Components/ListView/ListViewModal'

export default {
    name: 'InLawsuitIndex',
    components: { CollectionFilter, ListViewModal },
    props: {
        invoices: {
            type: Array,
            default: () => { return [] }
        },
        appliedFilters: {
            type: Object,
            default: () => {
                return {
                    invoiceId: null,
                    customerId: null,
                    customerSearch: null,
                    invoicePriceOperator: 'greater',
                    invoicePrice: null,
                    exclude_invoicesWithOpenIncidents: false,
                }
            }
        },
        checkedActions: {
            type: Object,
            default: () => { return {} }
        },
        headerCheckedActions: {
            type: Object,
            default: () => { return {} }
        },
        userListView: {
            type: Array,
            default: () => {
                return []
            }
        },
        currencyCodes: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            exclusion: {},
            form: this.$inertia.form({
                invoices: this.invoices
            }),
            filter: {
                invoiceId: this.appliedFilters.invoiceId,
                customerId: this.appliedFilters.customerId,
                customerSearch: this.appliedFilters.customerSearch,
                invoicePrice: this.appliedFilters.invoicePrice,
                invoicePriceOperator: this.appliedFilters.invoicePriceOperator === undefined ? 'greater' : this.appliedFilters.invoicePriceOperator,
                excludeInvoicesWithOpenIncidents: this.appliedFilters.excludeInvoicesWithOpenIncidents,
                currency: this.appliedFilters.currency
            },
            headerActions: {
                debit_loss: this.headerCheckedActions['debit_loss-header'] ?? false,
                ignore: this.headerCheckedActions['ignore-header'] ?? false
            },
            checkedActionsData: this.checkedActions,
            tableKey: 0,
            showListViewModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    watch: {
        invoices () {
            this.form = this.$inertia.form({
                invoices: this.invoices
            })
        }
    },
    created () {
        this.setPreselectedActions()
    },
    methods: {
        handoverCollections () {
            this.$inertia.post(this.$route('tools.in-lawsuit.set-debt-loss'), {
                invoices: this.form
                    .invoices
                    .filter((invoice) => invoice.debit_loss === true)
                    .map((invoice) => invoice.id)
            }, {
                onSuccess: () => {
                    this.setPreselectedActions()
                    ++this.tableKey
                }
            })
        },
        roundPrice (price, marketRegionId) {
            return price ? this.priceFormatForDisplay(price, 2, marketRegionId) : ''
        },
        getFields () {
            const availableList = [
                { key: 'debit_loss', label: '', _style: { minWidth: '10%' } },
                { key: 'ignore', label: '', _style: { minWidth: '10%' } },
            ]

            this.userListView.forEach((item) => {
                if (item.show_column === false) {
                    return
                }

                availableList.push({
                    key: item.column,
                    label: item.column !== 'actions' && item.column !== 'icon'
                        ? this.__('settings.list_view.' + item.list + '.' + item.column)
                        : '',
                    sorter: item.sort_column_enabled,
                    _style: item.width !== null
                        ? { minWidth: item.width + 'px', maxWidth: item.width + 'px' }
                        : {}
                })
            })

            return availableList
        },
        showInvoiceRoute (invoice) {
            return this.$route('customers.customers.invoices.show', {
                customer: invoice.customer.id,
                invoice: invoice.id
            })
        },
        customerInvoicesRoute (invoice) {
            return this.$route('customers.customers.invoices.index', { customer: invoice.customer.id })
        },
        applyFilter (defaultFilters = false) {
            const queryParameters = Object.fromEntries(Object.entries(this.filter).filter(([_, v]) => v))
            const radioButtonsData = {
                debit_loss: [],
                ignore: [],
                'debit_loss-header': 'false',
                'ignore-header': 'false'
            }

            for (const [key, arrayOfIds] of Object.entries(this.checkedActionsData)) {
                radioButtonsData[key] = arrayOfIds
            }

            for (const [key, value] of Object.entries(this.headerActions)) {
                radioButtonsData[`${key}-header`] = value === true ? 'true' : 'false'
            }

            this.$inertia.get(
                this.$route('tools.in-lawsuit.index', {
                    _query: queryParameters,
                    saveFilters: true,
                    defaultFilters: defaultFilters
                }),
                radioButtonsData,
                {
                    onSuccess: () => {
                        this.setPreselectedActions()
                    }
                }
            )
        },
        onChangeActions (activeInvoice, activeAction) {
            // Matches the value of the radio button that got checked, set to false all other
            this.form.invoices.forEach((invoice) => {
                if (invoice.id === activeInvoice.id) {
                    invoice.debit_loss = activeAction === 'debit_loss'
                    invoice.ignore = activeAction === 'ignore'

                    return false
                }
            })

            // Add or remove invoice id for specific action, we use checkedActionsData for preselecting radio buttons when use Filter
            for (const [key, arrayOfIds] of Object.entries(this.checkedActionsData)) {
                this.form.invoices.forEach((invoice) => {
                    if (invoice.id === activeInvoice.id) {
                        // Set new value for clicked button
                        if (key === activeAction) {
                            // Add invoice id in specific action array
                            if (arrayOfIds.includes(invoice.id) === false) {
                                this.checkedActionsData[key].push(invoice.id)
                            }
                        } else {
                            // Remove invoice id in specific action array
                            if (arrayOfIds.includes(invoice.id) === true) {
                                const idIndexOf = this.checkedActionsData[key].indexOf(invoice.id)
                                this.checkedActionsData[key].splice(idIndexOf, 1)
                            }
                        }
                    }
                })
            }

            this.headerActions.debit_loss = false
            this.headerActions.ignore = false
        },
        onClickAllActions (action) {
            const newValue = !this.headerActions[action]

            // Can not uncheck all ignore action
            if (action === 'ignore' && newValue === false) {
                return
            }

            this.headerActions.debit_loss = action === 'debit_loss' ? newValue : false
            this.headerActions.ignore = action === 'ignore' ? newValue : false

            // Matches the value of the radio button that got checked for all invoices, set to false all other invoice actions
            this.form.invoices.forEach((invoice) => {
                invoice.debit_loss = action === 'debit_loss' && newValue === true
                invoice.ignore = action === 'ignore' && newValue === true

                // If newValue is false set all ignore invoice buttons to true, that is default value
                if (newValue === false) {
                    invoice.ignore = true
                }
            })

            // Add or remove invoice id for specific action, we use checkedActionsData for preselecting radio buttons when use Filter
            for (const [key, arrayOfIds] of Object.entries(this.checkedActionsData)) {
                this.form.invoices.forEach((invoice) => {
                    if (newValue === true) {
                        // Set new value for clicked button
                        if (key === action) {
                            // Add invoice id in specific action array
                            if (arrayOfIds.includes(invoice.id) === false) {
                                this.checkedActionsData[key].push(invoice.id)
                            }
                        } else {
                            // Remove invoice id in specific action array
                            if (arrayOfIds.includes(invoice.id) === true) {
                                const idIndexOf = this.checkedActionsData[key].indexOf(invoice.id)
                                this.checkedActionsData[key].splice(idIndexOf, 1)
                            }
                        }
                    } else { // Set all ids to ignore array
                        if (key === 'ignore') {
                            // Add invoice id in specific action array
                            if (arrayOfIds.includes(invoice.id) === false) {
                                this.checkedActionsData[key].push(invoice.id)
                            }
                        } else {
                            // Remove invoice id in specific action array
                            if (arrayOfIds.includes(invoice.id) === true) {
                                const idIndexOf = this.checkedActionsData[key].indexOf(invoice.id)
                                this.checkedActionsData[key].splice(idIndexOf, 1)
                            }
                        }
                    }
                })
            }

            // Need to increase table key to refresh radio buttons data
            ++this.tableKey
        },
        setPreselectedActions  () {
            // Set invoice actions
            this.form.invoices.forEach((invoice) => {
                let checked = false
                let checkIgnore = true
                for (const [key, arrayOfIds] of Object.entries(this.checkedActionsData)) {
                    checked = arrayOfIds.includes(invoice.id) === true
                    invoice[key] = checked

                    if (checked) {
                        checkIgnore = false
                    }
                }

                if (checkIgnore) {
                    invoice.ignore = true
                }
            })

            this.headerActions.debit_loss = this.headerCheckedActions['debit_loss-header']
            this.headerActions.ignore = this.headerCheckedActions['ignore-header']
        }
    }
}
</script>

<style lang="scss" scoped>
.header-actions {
    display: grid;
    justify-items: flex-start;
    gap: 10px;
}
</style>
